var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.25H36C36.4142 8.25 36.75 8.58579 36.75 9V39C36.75 39.4142 36.4142 39.75 36 39.75H13.5C13.0858 39.75 12.75 39.4142 12.75 39V37.5H9V39C9 41.4853 11.0147 43.5 13.5 43.5H36C38.4853 43.5 40.5 41.4853 40.5 39V9C40.5 6.51472 38.4853 4.5 36 4.5H13.5C11.0147 4.5 9 6.51472 9 9V12H7.5C6.67157 12 6 12.6716 6 13.5C6 14.3284 6.67157 15 7.5 15H12.75C13.5784 15 14.25 14.3284 14.25 13.5C14.25 12.6716 13.5784 12 12.75 12V9C12.75 8.58579 13.0858 8.25 13.5 8.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27V33H7.5C6.67157 33 6 33.6716 6 34.5C6 35.3284 6.67157 36 7.5 36H12.75C13.5784 36 14.25 35.3284 14.25 34.5C14.25 33.6716 13.5784 33 12.75 33V27H9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 16.5V22.5C13.5784 22.5 14.25 23.1716 14.25 24C14.25 24.8284 13.5784 25.5 12.75 25.5H7.5C6.67157 25.5 6 24.8284 6 24C6 23.1716 6.67157 22.5 7.5 22.5H9V16.5H12.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 17.625C28.875 19.9144 27.0394 21.75 24.75 21.75C23.656 21.75 22.6068 21.3154 21.8332 20.5418C21.0596 19.7682 20.625 18.719 20.625 17.625C20.625 16.531 21.0596 15.4818 21.8332 14.7082C22.6068 13.9346 23.656 13.5 24.75 13.5C27.0394 13.5 28.875 15.3356 28.875 17.625Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26.4375C33 23.6944 27.4931 22.3125 24.75 22.3125C22.0069 22.3125 16.5 23.6944 16.5 26.4375V28.5H33V26.4375Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32.25C16.5 31.8358 16.8358 31.5 17.25 31.5H26.25C26.6642 31.5 27 31.8358 27 32.25V33.75C27 34.1642 26.6642 34.5 26.25 34.5H17.25C16.8358 34.5 16.5 34.1642 16.5 33.75V32.25Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 31.5C28.8358 31.5 28.5 31.8358 28.5 32.25V33.75C28.5 34.1642 28.8358 34.5 29.25 34.5H32.25C32.6642 34.5 33 34.1642 33 33.75V32.25C33 31.8358 32.6642 31.5 32.25 31.5H29.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.6a497693bc11a5ba03de70c73bab1630.svg";
export { ForwardRef as ReactComponent };